import * as React from 'react';
import { createFileRoute, Link } from '@tanstack/react-router';
import type { SystemRange } from '@/types';
import { fetchSystemGroupById } from '@/services.ts';
import {SYSTEMS_STALE_TIME_5_MINS} from '@/config';
import {queryOptions, useSuspenseQuery} from '@tanstack/react-query';
import {LoadingScreen} from '@/components/molecules/LoadingScreen.tsx';
import SystemImage from '@/components/atoms/SystemImage';
import { ErrorComponent } from '@/components/molecules/ErrorComponent';
import { BackButton } from '@/components/atoms/BackButton';

const systemGroupRangesQueryOptions = (systemGroupId: string) => queryOptions({
  queryKey: ['systemGroup', systemGroupId],
  queryFn: () => fetchSystemGroupById(systemGroupId),
  staleTime: SYSTEMS_STALE_TIME_5_MINS,
});

export const Route = createFileRoute('/systems/group/$systemGroupId/')({
  loader: async({ params, context }) => {
    const { systemGroupId } = params;
    return context.queryClient?.ensureQueryData(systemGroupRangesQueryOptions(systemGroupId));
  },
  pendingComponent: LoadingScreen,
  component: SystemGroupRanges
});

function SystemGroupRanges() {
  const { systemGroupId } = Route.useParams();
  const { error, data } = useSuspenseQuery(systemGroupRangesQueryOptions(systemGroupId));


  if(error) {
    return(<ErrorComponent error={error} />)
  }
  if(data) {
    const { systemGroup } = data;
    const generateUrl = (range) => `/systems/ranges/${range._id}`;
    const ranges = systemGroup.ranges || [];
    if(systemGroup) {
      return(
        <div className="p-4">
          <BackButton />
          <h1 className="text-3xl font-bold">{systemGroup.name}</h1>
          <div className="flex flex-row flex-wrap">
            {ranges.map((range: SystemRange): React.ReactElement => {
              const image = range.images[0] || null;
              return (
                <div
                  key={range._id}
                  className="basis-full flex-none md:basis-1/2 xl:basis-1/3 p-4"
                >
                  <div className="flex flex-row justify-center items-center p-16">  
                    <SystemImage image={image} />
                  </div>
                  <Link className="mt-4" to={generateUrl(range)}><h3 className="text-2xl font-thin">{range.name}</h3></Link>
                  <p>{range.description}</p>
                </div>
              )
            })}
          </div>
        </div>
      )
    }
    return (
      <div className="main-content"><h1 className="section-title">System Group Not Found</h1></div>
    )
  }
}
